import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";

const ListeUtilisateursAdmin = () => {
  const [utilisateurs, setUtilisateurs] = useState([]);
  const [search, setSearch] = useState("");

  const fetchUtilisateurs = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/admin/utilisateurs`, {
        withCredentials: true,
      });
      setUtilisateurs(res.data);
    } catch (err) {
      console.error("Erreur lors du chargement des utilisateurs", err);
    }
  };

  const supprimerUtilisateur = async (id) => {
    if (!window.confirm("Supprimer définitivement cet utilisateur ?")) return;
    try {
      await axios.delete(`${process.env.REACT_APP_API_URL}/api/admin/utilisateurs/${id}`, {
        withCredentials: true,
      });
      toast.success("Utilisateur supprimé !");
      fetchUtilisateurs(); // refresh list
    } catch (err) {
      console.error("Erreur suppression utilisateur", err);
      toast.error("Échec de la suppression");
    }
  };

  useEffect(() => {
    fetchUtilisateurs();
  }, []);

  return (
    <div style={{ padding: "1rem" }}>
      <h2>Utilisateurs enregistrés</h2>
      <input
        type="text"
        placeholder="Recherche par nom, prénom ou téléphone"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        style={{ padding: "8px", marginBottom: "1rem", width: "300px" }}
      />
      <table border="1" cellPadding="10" cellSpacing="0" style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th>Nom</th>
            <th>Prénom</th>
            <th>Pseudo</th>
            <th>Email</th>
            <th>Téléphone</th>
            <th>Ville</th>
            <th>Admin ?</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {utilisateurs
            .filter(
              (u) =>
                u.lastname?.toLowerCase().includes(search.toLowerCase()) ||
                u.firstname?.toLowerCase().includes(search.toLowerCase()) ||
                u.phone?.includes(search)
            )
            .map((user) => (
              <tr key={user._id}>
                <td>{user.lastname}</td>
                <td>{user.firstname}</td>
                <td>{user.pseudo}</td>
                <td>{user.email}</td>
                <td>{user.phone}</td>
                <td>{user.city || "-"}</td>
                <td>{user.isAdmin ? "✅" : "❌"}</td>
                <td>
                  <button onClick={() => supprimerUtilisateur(user._id)} style={{ backgroundColor: "red" }}>
                    Supprimer
                  </button>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default ListeUtilisateursAdmin;
